import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Card,
  CardBody,
} from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import {
  gAPI_Property_List_By_Group,
  gAPI_Internal_Property_By_Id,
  dAPI_Delete_Ingetration,
  API_Phone_Suite_Interation_Group,
  API_Phone_Suite,
  API_ELEVEN_LABS,
} from '../../../../../../constants/APIs';
import VoiceAndBehavior from './VoiceAndBehaviour';
import { NavLink } from 'react-router-dom';
import { faHistory, faLanguage, faSms } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IntegrationInfo from './IntegrationInfo';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import ConnectWareSettings from './ConnectWareSettings';
import SecuritySettings from './SecuritySettings';
import Features from './Features';
import ConfigurationBehavior from './configurationBehavior';
// import SMS from './SMS';
import Topics from './Topics';
import VoiceAndBehaviour from './VoiceAndBehaviour';
import { fetchServiceRequest } from '../../../../../../redux/actions';
import PublishIntegration from './PublishIntegration';
function PhoneSuiteIntegrationList({
  match,
  locale,
  propertyId,
  featuresUrl,
  serviceProvider,
  fetchServiceRequest,
}) {
  const integrationId = match.params.id;
  const [integration, setIntegration] = useState();
  const [allProperties, setAllProperties] = useState([]);
  const [propertyVisible, setPropertyVisible] = useState(true);
  const [featuresVisible, setFeaturesVisible] = useState(false);
  const [connectWareVisible, setConnectWareVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [publishVisible, setPublishVisible] = useState(false);
  const [langVisible, setLangVisible] = useState(false);
  const [smsVisible, setSMSVisible] = useState(false);
  const [voiceAssistantVisible, setVoiceAssistantVisible] = useState(false);
  const [configurationVisible, setConfiguraionVisible] = useState(false);
  const [propertyData, setPropertyData] = useState([]);
  const [topics, setTopics] = useState(false);

  useEffect(() => {
    if (serviceProvider) {
      fetchServiceRequest(serviceProvider);
    }
  }, [serviceProvider]);

  const preview_demo =
    featuresUrl !== null &&
    featuresUrl !== undefined &&
    !featuresUrl.includes('myma.ai')
      ? `https://preview.${featuresUrl}/messenger-preview`
      : process.env.REACT_APP_MESSENGER_DEMO;

  const property = () => {
    setSMSVisible(false);
    setPropertyVisible(true);
    setFeaturesVisible(false);
    setConnectWareVisible(false);
    setTopics(false);
    setConfiguraionVisible(false);
    setPublishVisible(false);
    setLangVisible(false);
    setVoiceAssistantVisible(false);
  };

  const connectWareSettings = () => {
    setSMSVisible(false);
    setPropertyVisible(false);
    setFeaturesVisible(false);
    setTopics(false);
    setConnectWareVisible(true);
    setConfiguraionVisible(false);
    setPublishVisible(false);
    setLangVisible(false);
    setVoiceAssistantVisible(false);
  };

  const features = () => {
    setSMSVisible(false);
    setPropertyVisible(false);
    setFeaturesVisible(true);
    setConnectWareVisible(false);
    setTopics(false);
    setConfiguraionVisible(false);
    setPublishVisible(false);
    setLangVisible(false);
    setVoiceAssistantVisible(false);
  };

  const language = () => {
    setSMSVisible(false);
    setPropertyVisible(false);
    setFeaturesVisible(false);
    setConnectWareVisible(false);
    setConfiguraionVisible(false);
    setTopics(false);
    setPublishVisible(false);
    setLangVisible(true);
    setVoiceAssistantVisible(false);
  };

  const voiceAssistant = () => {
    setSMSVisible(false);
    setPropertyVisible(false);
    setFeaturesVisible(false);
    setConnectWareVisible(false);
    setTopics(false);
    setConfiguraionVisible(false);
    setPublishVisible(false);
    setLangVisible(false);
    setVoiceAssistantVisible(true);
  };

  const configuration = () => {
    setSMSVisible(false);
    setPropertyVisible(false);
    setTopics(false);
    setFeaturesVisible(false);
    setConnectWareVisible(false);
    setConfiguraionVisible(true);
    setPublishVisible(false);
    setLangVisible(false);
    setVoiceAssistantVisible(false);
  };

  const publish = () => {
    setSMSVisible(false);
    setTopics(false);
    setPropertyVisible(false);
    setFeaturesVisible(false);
    setConnectWareVisible(false);
    setConfiguraionVisible(false);
    setPublishVisible(true);
    setLangVisible(false);
    setVoiceAssistantVisible(false);
  };

  const handleTopics = () => {
    setSMSVisible(false);
    setTopics(true);
    setPropertyVisible(false);
    setFeaturesVisible(false);
    setConnectWareVisible(false);
    setConfiguraionVisible(false);
    setPublishVisible(false);
    setLangVisible(false);
    setVoiceAssistantVisible(false);
  };

  useEffect(() => {
    LoadIntegration();
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
    }).then((res) => {
      setPropertyData(res.data);
    });
  }, [integrationId]);
  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    }).then((res) => {
      setAllProperties(res.data);
    });
  }, []);
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const LoadIntegration = () => {
    AxiosAPI({
      method: 'get',
      url: `${API_Phone_Suite}/${integrationId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setIntegration(res.data);
      })
      .catch((err) => console.log('err', err));
  };

  const updateOrCreateAgent = (id) => {
    console.log('integration to update or create', integration);
    console.log(
      'features to update or create',
      integration?.phoneSuiteIntegration?.features?.agentId
    );
    if (
      integration?.phoneSuiteIntegration?.features?.voiceProcessing ===
      'ElevenLabs'
    ) {
      if (integration?.phoneSuiteIntegration?.features?.agentId) {
        // Update existing integration
        return AxiosAPI({
          method: 'put',
          url: `${API_ELEVEN_LABS}/agents?iid=${id}&groupId=${getGroupID()}`,
          data: integration,
        });
      } else {
        // Create new integration
        return AxiosAPI({
          method: 'post',
          url: `${API_ELEVEN_LABS}/agents?iid=${id}&groupId=${getGroupID()}`,
          data: integration,
        });
      }
    }
  };

  const updateModel = integration
    ? {
        name: integration.name,
        properties: integration.properties,
        defaultLanguage: 'en-US',
        security: integration?.phoneSuiteIntegration?.security,
        languages: integration?.phoneSuiteIntegration?.languages,
        sessionTimeoutInSeconds: integration.sessionTimeoutInSeconds,
        connectionSettings:
          integration?.phoneSuiteIntegration?.connectionSettings,
        features: integration?.phoneSuiteIntegration?.features,
        configurationSettings:
          integration?.phoneSuiteIntegration?.configurationSettings,
        smsSettings: integration?.phoneSuiteIntegration?.smsSettings,
      }
    : null;

  const saveIntegration = (data) => {
    const {
      list,
      name,
      configurationSettings,
      smsSettings,
      security,
      features,
      connectionSettings,
      topics,
      languages,
    } = data;
    console.log(features, 'features in save integration');
    if (list) {
      updateModel.properties = list;
    }
    if (topics) updateModel.topics = topics;
    if (name) {
      updateModel.name = name;
    }
    if (connectionSettings) {
      updateModel.connectionSettings = connectionSettings;
    }
    if (configurationSettings) {
      updateModel.configurationSettings = configurationSettings;
    }
    if (smsSettings) {
      updateModel.smsSettings = smsSettings;
    }
    if (features) {
      updateModel.features = features;
    }
    if (security) {
      updateModel.security = security;
    }
    if (languages) {
      updateModel.languages = languages;
    }
    
    AxiosAPI({
      method: 'put',
      url: `${API_Phone_Suite}/${integration.id}?group_id=${getGroupID()}`,
      data: updateModel,
    })
      .catch((err) => console.error(err))
      .then(() => {
        // updateOrCreateAgent(integration?.id);
        let groupRequest = {
          groupId: getGroupID(),
          propertyId: updateModel.properties[0],
          agentId: updateModel.features?.agentId,
          domain:
            updateModel.connectionSettings.sipGateway === 'Myma.ai'
              ? updateModel.connectionSettings.originatingPhoneNumber
              : updateModel.connectionSettings.domain,
          inboundTrunkName: updateModel.connectionSettings.inboundTrunk,
          creator: 'Dashboard',
        };
        groupRequest.integrationId = integration.id;
        AxiosAPI({
          method: 'put',
          url: `${API_Phone_Suite_Interation_Group}/${integration.id}`,
          data: groupRequest,
        }).then(() => {});
        LoadIntegration();
        NotificationManager.success(
          '',
          'Integration update successfully',
          3000,
          null,
          null,
          'success'
        );
      });
  };
  const handleDelete = () => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${
        integration.id
      }/?group_id=${getGroupID()}`,
    }).then((res) => {
      let updateRequest = {
        updater: 'dashboard',
      };
      AxiosAPI({
        method: 'delete',
        url: `${API_Phone_Suite_Interation_Group}/${integration.id}`,
        data: updateRequest,
      })
        .then((result) => {
          toggle();
          window.location.href = '/app/pages/integration/applications';
        })
        .catch((err) => {
          console.log('err', err);
        });
    });
  };
  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This integration will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  const RedirectToDemo = () => {
    var url = `https://elevenlabs.io/app/agents/agents/${integration?.phoneSuiteIntegration?.features?.agentId}/preview`;
    window.open(url, '_blank');
  };

  const handleAgent = async () => {
    try {
      // If features.agentId exists, update, else create
      if (integration?.phoneSuiteIntegration?.features?.agentId) {
        await AxiosAPI({
          method: 'put',
          url: `${API_ELEVEN_LABS}/agents?iid=${integration?.id}&groupId=${getGroupID()}`,
          data: integration,
        });
      } else {
        await AxiosAPI({
          method: 'post',
          url: `${API_ELEVEN_LABS}/agents?iid=${integration?.id}&groupId=${getGroupID()}`,
          data: integration,
        });
      }
      NotificationManager.success(
        'Published to Eleven Labs successfully!',
        'Publish'
      );
    } catch (err) {
      NotificationManager.error(
        'Failed to publish to Eleven Labs.',
        'Publish Error'
      );
    }
  };

  const updatePreviousVersion = ( data) => {
    if (data?.configurationSettings) {
      updateModel.configurationSettings = data.configurationSettings;
    }
    if (data?.features) {
      updateModel.features = data?.features;
    }
    if (data?.security) {
      updateModel.security = data?.security;
    }
    AxiosAPI({
      method: 'put',
      url: `${API_Phone_Suite}/${integration.id}?group_id=${getGroupID()}`,
      data: updateModel,
    })
      .catch((err) => console.error(err))
      .then(() => {
        // updateOrCreateAgent(integration?.id);
        handleAgent();
        LoadIntegration();
        let groupRequest = {
          groupId: getGroupID(),
          propertyId: updateModel.properties[0],
          domain:
            updateModel.connectionSettings.sipGateway === 'Myma.ai'
              ? updateModel.connectionSettings.originatingPhoneNumber
              : updateModel.connectionSettings.domain,
          inboundTrunkName: updateModel.connectionSettings.inboundTrunk,
          creator: 'Dashboard',
        };
        groupRequest.integrationId = integration.id;
        AxiosAPI({
          method: 'put',
          url: `${API_Phone_Suite_Interation_Group}/${integration.id}`,
          data: groupRequest,
        }).then(() => {});
        LoadIntegration();
        NotificationManager.success(
          '',
          'Integration update successfully',
          3000,
          null,
          null,
          'success'
        );
      });
  };  
  return (
    <Fragment>
      {integration ? (
        <Fragment>
          <Row>
            <Colxx md="12" sm="12" lg="12" xxs="12">
              <NavLink to={{ pathname: '/app/pages/integration/channels' }}>
                <h1 className="iconsminds-back" />
              </NavLink>
            </Colxx>
          </Row>
          <Row>
            <Colxx xxs="12" md="6" className="mb-4">
              <Card>
                <CardBody>
                  {/* 1. Select Property */}
                  <div
                    className={`mb-3 integration ${propertyVisible ? 'integration--active' : ''}`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-hotel`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => property()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Select Property
                          </p>
                          <p className="mb-4 text-small">
                            Select the business name for this integration
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>

                  {/* 2. Conversational Behavior */}
                  <div
                    className={`mb-3 integration ${configurationVisible ? 'integration--active' : ''}`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-mic`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => configuration()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Conversational Behavior
                          </p>
                          <p className="mb-4 text-small">
                            Select the flows, the call behavior, and the prompts
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>

                  {/* 4. Features (with SMS) */}
                  <div
                    className={`mb-3 integration ${featuresVisible ? 'integration--active' : ''}`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon simple-icon-game-controller`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => features()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Features
                          </p>
                          <p className="mb-4 text-small">
                            Select the capabilities and features you want to
                            enable, including SMS
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>

                  {/* 5. Keep Your Voice AI Secure */}
                  {/* SMS section removed, now in Features */}
                  <div
                    className={`mb-3 integration ${
                      langVisible ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faLanguage} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => language()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Voices & Languages
                          </p>
                          <p className="mb-4 text-small">
                            Select the languages you want to support
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${voiceAssistantVisible ? 'integration--active' : ''}`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon iconsminds-security-settings`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => voiceAssistant()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Keep Your Voice AI Secure
                          </p>
                          <p className="mb-4 text-small">
                            Keep Your AI Voice Assistant Secure
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  {/* 7. Publish Changes */}
                  <div
                    className={`mb-3 integration ${
                      connectWareVisible ? 'integration--active' : ''
                    }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-phone-3`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => connectWareSettings()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Connect to Phone Number
                          </p>
                          <p className="mb-4 text-small">
                            Setup the forwarding rules
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${publishVisible ? 'integration--active' : ''}`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon iconsminds-monitor---tablet`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => publish()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Publish Changes
                          </p>
                          <p className="mb-4 text-small">
                            Publish your changes to update your AI Voice
                            Assistant
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      disabled={!integration?.phoneSuiteIntegration?.features?.agentId}
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={RedirectToDemo}
                    >
                      Preview
                    </Button>

                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      outline
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={toggle}
                    >
                      Archive
                    </Button>

                    <Separator />
                  </div>
                </CardBody>
              </Card>
            </Colxx>
            <Colxx xxs="12" md="6" className="mb-4">
              {propertyVisible && (
                <Fragment>
                  <IntegrationInfo
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationProperties={
                      integration.properties === null
                        ? []
                        : integration.properties
                    }
                    allProperties={allProperties}
                  />
                  {/* <Example url="https://assets.bookmebob.com/images/integration-example/properties.png" /> */}
                </Fragment>
              )}
              {langVisible && (
                <Fragment>
                  <VoiceAndBehavior
                    settings={integration?.phoneSuiteIntegration}
                    saveIntegration={saveIntegration}
                    onLanguageChange={(lang) => {
                      // Optionally update integration or call saveIntegration
                      // For now, just log or handle as needed
                      // Example: saveIntegration({ ...integration, defaultLanguage: lang })
                    }}
                  />
                </Fragment>
              )}
              {configurationVisible && (
                <Fragment>
                  <ConfigurationBehavior
                    locale={locale}
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                  />
                </Fragment>
              )}
              {/* SMS settings now handled in Features */}
              {voiceAssistantVisible && (
                <Fragment>
                  <SecuritySettings
                    securitySettings={
                      integration?.phoneSuiteIntegration?.security
                    }
                    saveIntegration={saveIntegration}
                  />
                </Fragment>
              )}
              {publishVisible && (
                <PublishIntegration updatePreviousVersion={updatePreviousVersion} handleAgent={handleAgent} versionHistory={integration?.phoneSuiteIntegration?.versions || []} />
              )}
              {connectWareVisible && (
                <Fragment>
                  <ConnectWareSettings
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                  />
                </Fragment>
              )}
              {topics && (
                <Fragment>
                  <Topics
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" /> */}
                </Fragment>
              )}
              {featuresVisible && (
                <Fragment>
                  <Features
                    settings={integration?.phoneSuiteIntegration}
                    saveIntegration={saveIntegration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    integration={integration}
                    botSettings={integration.botSettings}
                    locale={locale}
                  />
                </Fragment>
              )}
            </Colxx>
          </Row>
        </Fragment>
      ) : null}
      {generateDeleteButton()}
    </Fragment>
  );
}
const mapStateToProps = ({ settings, service }) => {
  const { propertyId, locale, serviceProvider } = settings;
  const { featuresUrl } = service;
  return {
    propertyId,
    locale,
    serviceProvider,
    featuresUrl,
  };
};
const mapDispatchToProps = {
  fetchServiceRequest,
};
export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(PhoneSuiteIntegrationList)
);
